<template> 
 
    <div class="col-24">

      <div class='d-flex align-self-start'>
        <div class='position-relative align-self-center d-flex align-items-center align-self-center'>
          <div class='circle-number d-flex justify-content-center align-items-center'>
            <span>{{number}}</span>
          </div>
        </div>
        <div class='pl-3 d-flex'>
          <div class='align-self-start mt-1'>
            <h2 class='size-1_4 m-0 pb-1'><strong v-text="$ml.get('outOfScopeTitle')">Fora de Escopo</strong></h2>
            <p class='d-flex align-items-center'>
              <span class='align-self-center' v-text="$ml.get('limitOutOfScope')">
                Quais aplicações não devem ser testadas?
              </span>
            </p>
          </div>
        </div>
      </div>

      <div class='d-flex align-self-start h-profile'>
        <div class='v-line d-flex align-items-stretch'><span class='pb-4'></span></div>
      </div>

      <div class='d-flex align-self-start h-profile-circle'>
        <div class='circle d-flex justify-content-center'>
          <span class='circle-internal d-flex justify-content-center'><span class='circle-primary'></span></span>
          <div class='h-line'><span></span></div>
          <div class='v-line'><span></span></div>
        </div>
        <div class='d-flex flex-column w-100 mr-3'>
          <p class='pl-3 mb-3' v-text="$ml.get('delimitDomains')">Delimite domínios, subdomínios, aplicativos e outros</p>

          <div class='d-flex pl-3 w-100 mb-3'> 
            <div class='row w-100 d-flex align-items-center'>
              <div class='col-lg-7 col-md-14 pr-3 pb-2 col-22'>
                <input maxlength="100" type='text' class='form-control' v-model="txtOutOfScope" :placeholder="$ml.get('informTheScope')">
                <transition name="fade">
                  <label v-if="validateScopeError && !$v.txtOutOfScope.required" class="lblError" v-text="$ml.get('theScopeAddressMustBeInformed')">Informe o endereço do escopo</label>
                  <label class="lblError" v-if="validateScopeError && !$v.txtOutOfScope.minLength">O escopo deve ter entre 3 e 40 caracteres</label>
                </transition>
              </div>

              <div :class="'pr-3 pb-2 col-22 '+  (typeProgram != 'vdp' ? 'col-lg-7 col-md-12' : 'col-lg-10 col-md-12')" class=''>
                <multiselect  
                  v-model="selectedOutOfScopeType" 
                  label="" 
                  :custom-label="nameLang"
                  :options="selectScopeType" 
                  :searchable="false"
                  :close-on-select="true"
                  :show-labels="false"  
                  :placeholder="$ml.get('scopeType')">
                </multiselect>  
                <transition name="fade">
                  <label v-if="validateScopeError && !$v.selectedOutOfScopeType.required" 
                   class="lblError" v-text="$ml.get('selectScopeType')">Selecione o tipo de escopo</label>
                </transition>  
              </div>

              <div class='col d-flex justify-content-end mr-2 pointer'>
                <button class="btn" @click="addOutOfScope()" v-text="$ml.get('include')">Incluir</button>
              </div>
            </div>
          </div>

          <div class='card card-body ml-3 p-0 d-flex w-100'> 
            <div v-if="!listOutOfScope.length" class="d-flex justify-content-center">
              <h6 :class="validateError && !$v.listOutOfScope.required ? 'size-1_4 p-4 text-danger' : 'size-1_4 p-4 '" v-text="$ml.get('addOutOfScopesHere')">Adicione os escopos aqui!</h6> 
            </div> 
            <table v-else v-show="listOutOfScope.length" class='mb-2'>
              <thead>
                <tr>
                  <th class='col-9' v-text="$ml.get('scope')">Escopo</th>
                  <th :class="'pl-0 col-9'" v-text="$ml.get('type')">Tipo</th>
                  <th v-if="typeProgram != 'vdp'" class='col-5 pl-0'>Bounty</th> 
                  <th class='col-2'></th>
                  <th class='col-2'></th>
                </tr>
              </thead>
              <tbody> 
                <tr v-for="(item, index) in listOutOfScope" :key="index"> 
                  <td class='col-9 d-flex align-items-center text-break'><strong>{{item.description}}</strong></td>
                  <td :class="'pl-0 text-muted d-flex align-items-center col-9'">{{nameLang( item.type )}}</td>
                  
                  <td v-if="typeProgram != 'vdp'" class='col-4 pl-0 d-flex align-items-center'>
                    <div v-if="item.offers_bounty" class="row">
                      <img class="img-money" src="../../../assets/images/money.png" />
                      <strong class="text-success   align-items-center d-none d-md-flex" v-text="$ml.get('eligible')">Elegivel</strong>
                    </div>
                    <div v-if="!item.offers_bounty" class="row">
                      <img class="img-money" src="../../../assets/images/no-money.png" />
                      <strong class="text-danger   align-items-center d-none d-md-flex" v-text="$ml.get('notEligible')">Inelegivel</strong>
                    </div>
                  </td>

                  <td class='col-2 pl-0 d-flex justify-content-end align-items-center'>
                    <a class='pointer' @click="removeOutOfScope(index)"> 
                      <svg width="16" height="16">       
                        <image xlink:href="../../../../src/assets/icons/trash-alt.svg" width="16" height="16"/>    
                      </svg> 
                    </a>
                  </td>
                </tr> 
              </tbody> 
            </table> 
          </div>
        </div>
      </div>

      <div class='d-flex align-self-start h-profile'>
        <div class='v-line d-flex align-items-stretch'><span class='pb-5'></span></div>
      </div>
 
    </div>
  
</template>
<script>
import { required, minLength } from "vuelidate/lib/validators";
import Swal from 'sweetalert2';
// import PlanService from "../../../services/plan.service"; 

export default {
  name: "OutOfScope",
  props:{
    number: {
      type: String,
      required: true
    },
    typeProgram: {
      type: String,
      required: true
    },
    listOutOfScope: {
      type: Array,
      required: false,
      default: Array,
    },
    listOutOfScopeRemove: {
      type: Array,
      required: false,
      default: Array,
    },
    validateError: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
 
  components: {},
  data() {
    return {  
      validateScopeError: false,
      txtOutOfScope: '',

      selectedOutOfScopeType: "", 
      selectedImpact: null, 
      selectedElegivel: null, 
 
      selectScopeType: [
        'url',
        'web',
        'api',
        'mobile-application-android',
        'mobile-application-ios',
        'domain',
        'subdomain',
        'ip',
        'other',
      ],
    };
  },
  validations: {  
    txtOutOfScope: { required, minLength: minLength(3) },
    selectedOutOfScopeType: { required }, 
    listOutOfScope: { required }, 
  },
  mounted() {
  },
  methods: {
    // Altera o idioma dos itens do select
    nameLang ( name ) {
      if(!['-'].includes(name) && name){
        return this.$ml.get(name.replaceAll('-','')) 
      }
      return name;
    },

    async addOutOfScope(){
      var self = this;

      this.$v.$touch()   
      if (this.$v.txtOutOfScope.$error || 
          this.$v.selectedOutOfScopeType.$error
         ) {
          this.validateScopeError = true; 
        return
      }
 
      let newItem = {
          description: this.txtOutOfScope, 
          type: this.selectedOutOfScopeType, 
        };
   
      let diference = false;

       
      await this.listOutOfScope.forEach(element => { 
        if(element.description === newItem.description){
          Swal.fire({
            icon: 'info',
            title: '',
            text: self.$ml.get('cannotEnterEqualScopes'),
          }) 
          diference = true;
          return;
        } 

        if(JSON.stringify(element) === JSON.stringify(newItem)){
          Swal.fire({
            icon: 'info',
            title: '',
            text: self.$ml.get('cannotEnterEqualScopes'),
          }) 
          diference = true;
          return;
        } 
      });
       
      this.validateScopeError = false;
      if(!diference){
        this.txtOutOfScope = '';
        this.selectedOutOfScopeType = null; 
        this.listOutOfScope.push(newItem)  
      }
    }, 

    removeOutOfScope(item){
      this.listOutOfScope[item].status = 'inactive';
      this.listOutOfScopeRemove.push(this.listOutOfScope[item])
      this.listOutOfScope.splice(item, 1); 
    },
     
  },
};
</script>  


  
